import React, { useState, useRef, useEffect, forwardRef } from "react";
import styled from "@emotion/styled";
import "react-datepicker/dist/react-datepicker.css";
import 'react-csv-importer/dist/index.css';
import "../../../../styles.css";
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from "@mui/icons-material/Error";
import DatePicker from 'react-datepicker';
import { useTheme } from "@mui/styles";
import CircularProgress from "@mui/material/CircularProgress";
import {addDays, subMonths} from 'date-fns';
import PaymentScheduleDropdown from "../../../DropDowns/PaymentScheduleDropdown";
import { useDispatch, useSelector } from "react-redux";
import { setLeadActionNavMenuSelection } from "../../../../slices/sessionDataSlice";
import { selectTeamDefaultInterestRate, selectTeamPaymentSchedules } from "../../../../slices/teamAndUserSettingsSlice";
import { useEditOneMortgageDetailMutation, useProvideFinancialInformationMutation, useReloadTeamPortfolioMonthlyStatsMutation } from "../../../../slices/api/apiSlice";
import { selectSaveFinancialInformationEnabled, setSaveFinancialInformationEnabled } from "../../../../slices/functionAvailabilitySlice";
import { ErrorWrapper, InputWrapper, StatusAndLabelWrapper, StyledInputElement, Button, ButtonWrapper, FlexWrapper, Typography } from "../../../../StyledComponents";

const ProvideFinancials = ({ mortgageData, userFullName, leadData, navSelection, handleCloseModal, userId, teamId, origin }) => {
  const theme = useTheme()
  const dispatch = useDispatch()

  const [reloadTeamPortfolioMonthlyStats] = useReloadTeamPortfolioMonthlyStatsMutation()
  const [provideFinancialInformation] = useProvideFinancialInformationMutation()
  const [editOneMortgageDetail] = useEditOneMortgageDetailMutation()

  const saveFinancialInformationEnabled = useSelector(selectSaveFinancialInformationEnabled)
  const teamDefaultInterestRate = useSelector(selectTeamDefaultInterestRate)
  const teamPaymentSchedules = useSelector(selectTeamPaymentSchedules)

  const [newPaymentSchedule, setNewPaymentSchedule] = useState('')
  const [newPaymentScheduleLabel, setNewPaymentScheduleLabel] = useState('')
  const [invalidInputs, setInvalidInputs] = useState(false)
  const [mortgageDateRequired, setMortgageDateRequired] = useState(false)
  const [mortgageTermRequired, setMortgageTermRequired] = useState(false)
  const [loanAmountRequired, setLoanAmountRequired] = useState(false)
  const [interestRateRequired, setInterestRateRequired] = useState(false)
  const [amortizationScheduleRequired, setAmortizationScheduleRequired] = useState(false)
  const [startDate, setStartDate] = useState(new Date())
  const [saveIsFetching, setSaveIsFetching] = useState(false)
  const [saveIsSuccess, setSaveIsSuccess] = useState(false)
  const [saveIsError, setSaveIsError] = useState(false)
  const [statusMortgageTerm, setstatusMortgageTerm] = useState(null)
  const [mortgageTerm, setMortgageTerm] = useState('')
  const mortgageTermRef = useRef()
  const [statusOriginalLoanAmount, setStatusOriginalLoanAmount] = useState(null)
  const [originalLoanAmountStr, setOriginalLoanAmountStr] = useState('')
  const [originalLoanAmount, setOriginalLoanAmount] = useState('')
  const originalLoanAmountRef = useRef()
  const [statusOriginalInterestRate, setStatusOriginalInterestRate] = useState(null)
  const [originalInterestRate, setOriginalInterestRate] = useState('')
  const originalInterestRateRef = useRef()

  const ExampleCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
    <input
      value={value}
      className="styled-calendar-input-icon-left"
      onClick={onClick}
      onChange={onChange}
      ref={ref}
    />
  ))

  const handleSetNewPaymentSchedule = (event) => {
    setNewPaymentSchedule(event.target.value)
    let newScheduleType = teamPaymentSchedules.find(schedule => schedule._id.toString() === event.target.value.toString())
    if (newScheduleType) {
      setNewPaymentScheduleLabel(newScheduleType.label)
    }
  }

  const validateMortgageTerm = async () => {
    let validated = true
    if (mortgageTermRequired) {
      validated = false
      setMortgageTerm(mortgageTermRef.current.value)
      let negativeTerm = Math.sign(parseFloat(mortgageTermRef.current.value))
      let zeroTerm = Math.sign(parseFloat(mortgageTermRef.current.value))
      if (negativeTerm === -1 || zeroTerm === 0 || isNaN(parseFloat(mortgageTermRef.current.value)) || parseFloat(mortgageTermRef.current.value) > 99 || parseFloat(mortgageTermRef.current.value) % 1 !== 0 || !parseInt(mortgageTermRef.current.value) > 0) {
        if (!parseInt(mortgageTermRef.current.value) > 0) {
          setstatusMortgageTerm('required')
        }
        if (parseFloat(mortgageTermRef.current.value) % 1 !== 0) {
          setstatusMortgageTerm('decimal')
        }
        if (negativeTerm === -1) {
          setstatusMortgageTerm('negative')
        }
        if (zeroTerm === 0) {
          setstatusMortgageTerm('zero')
        }
        if (isNaN(parseFloat(mortgageTermRef.current.value))) {
          setstatusMortgageTerm('nonNumber')
        }
        if (parseFloat(mortgageTermRef.current.value) > 99) {
          setstatusMortgageTerm('large')
        }
        dispatch( setSaveFinancialInformationEnabled(false) )
      } else {
        setInvalidInputs(false)
        setstatusMortgageTerm(null)
        if (saveIsError) {
          setSaveIsError(false)
        }
        if (((interestRateRequired && !statusOriginalInterestRate) || !interestRateRequired) && ((loanAmountRequired && !statusOriginalLoanAmount) || !loanAmountRequired)) {
          dispatch( setSaveFinancialInformationEnabled(true) )
          validated = true
        }
      }
    }
    return validated
  }
  const validateLoanAmount = async () => {
    let validated = true
    if (loanAmountRequired) {
      validated = false
      if ((parseInt(originalLoanAmountRef.current.value.replace(/,/g, "")) < 100000000 || (isNaN(parseInt(originalLoanAmountRef.current.value.replace(/,/g, ""))))) && originalLoanAmountRef.current.value.length < 12) {
        if (!isNaN(parseInt(originalLoanAmountRef.current.value))) {
          setOriginalLoanAmountStr(parseInt(originalLoanAmountRef.current.value.replace(/,/g, "")).toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0}))
        } else {
          setOriginalLoanAmountStr(originalLoanAmountRef.current.value)
        }
        setOriginalLoanAmount(parseInt(originalLoanAmountRef.current.value.replace(/[^0-9-.]/g, '')))
      }
      let negativeAmount = Math.sign(parseFloat(originalLoanAmountRef.current.value))
      let zeroAmount = Math.sign(parseFloat(originalLoanAmountRef.current.value))
      if (negativeAmount === -1 || zeroAmount === 0 || isNaN(parseFloat(originalLoanAmountRef.current.value)) || parseFloat(originalLoanAmountRef.current.value) > 100000000 || parseFloat(originalLoanAmountRef.current.value) % 1 !== 0 || !parseFloat(originalLoanAmountRef.current.value) > 0) {
        if (!parseFloat(originalLoanAmountRef.current.value) > 0) {
          setStatusOriginalLoanAmount('required')
        }
        if (parseFloat(originalLoanAmountRef.current.value) % 1 !== 0) {
          setStatusOriginalLoanAmount('decimal')
        }
        if (negativeAmount === -1) {
          setStatusOriginalLoanAmount('negative')
        }
        if (zeroAmount === 0) {
          setStatusOriginalLoanAmount('zero')
        }
        if (isNaN(parseFloat(originalLoanAmountRef.current.value))) {
          setStatusOriginalLoanAmount('nonNumber')
        }
        if (parseFloat(originalLoanAmountRef.current.value) > 100000000) {
          setStatusOriginalLoanAmount('large')
        }
        dispatch( setSaveFinancialInformationEnabled(false) )
      } else {
        setInvalidInputs(false)
        setStatusOriginalLoanAmount(null)
        if (saveIsError) {
          setSaveIsError(false)
        }
        if (((interestRateRequired && !statusOriginalInterestRate) || !interestRateRequired) && ((mortgageTermRequired && !statusMortgageTerm) || !mortgageTermRequired)) {
          dispatch( setSaveFinancialInformationEnabled(true) )
          validated = true
        }
      }
    }
    return validated
  }
  const validateInterestRate = async () => {
    let validated = true
    if (interestRateRequired) {
      validated = false
      setOriginalInterestRate(originalInterestRateRef.current.value)
      let negativeInterest = Math.sign(parseFloat(originalInterestRateRef.current.value))
      let zeroInterest = Math.sign(parseFloat(originalInterestRateRef.current.value))
      if (negativeInterest === -1 || zeroInterest === 0 || isNaN(parseFloat(originalInterestRateRef.current.value)) || parseFloat(originalInterestRateRef.current.value) > 99 || !parseFloat(originalInterestRateRef.current.value) > 0) {
        if (!parseFloat(originalInterestRateRef.current.value) > 0) {
          setStatusOriginalInterestRate('required')
        }
        if (negativeInterest === -1) {
          setStatusOriginalInterestRate('negative')
        }
        if (zeroInterest === 0) {
          setStatusOriginalInterestRate('zero')
        }
        if (isNaN(parseFloat(originalInterestRateRef.current.value))) {
          setStatusOriginalInterestRate('nonNumber')
        }
        if (parseFloat(originalInterestRateRef.current.value) > 99) {
          setStatusOriginalInterestRate('large')
        }
        dispatch( setSaveFinancialInformationEnabled(false) )
      } else {
        setInvalidInputs(false)
        setStatusOriginalInterestRate(null)
        if (saveIsError) {
          setSaveIsError(false)
        }
        if (((loanAmountRequired && !statusOriginalLoanAmount) || !loanAmountRequired) && ((mortgageTermRequired && !statusMortgageTerm) || !mortgageTermRequired)) {
          dispatch( setSaveFinancialInformationEnabled(true) )
          validated = true
        }
      }
    }
    return validated
  }

  const handleSave = async () => {
    setSaveIsFetching(true)
    let recordUpdateError = false
    let validateTerm = await validateMortgageTerm()
    let validateAmount = await validateLoanAmount()
    let validateInterest = await validateInterestRate()
    if (validateTerm && validateAmount && validateInterest) {
      let newOriginationDate = ''
      let newMortgageTerm = 0
      let newOriginalLoanAmount = 0
      let newOriginalInterestRate = 0
      let leadStatus = null
      let leadId = null
      if (leadData) {
        leadStatus = leadData.status
        leadId = leadData._id
      }
      if (mortgageData.originationDate.length > 0) {
        newOriginationDate = mortgageData.originationDate
      } else {
        newOriginationDate = startDate
        let resp = await editOneMortgageDetail({
          userId: userId,
          userFullName: userFullName,
          mortgageId: mortgageData._id,
          leadId: leadId,
          recordField: 'PrimaryMortgageStartDate',
          customValue: startDate,
          activeDiscrepancies: mortgageData.activeDiscrepancies,
          resolvedDiscrepancies: mortgageData.resolvedDiscrepancies,
          rejectedDiscrepancies: mortgageData.rejectedDiscrepancies,
          publicRecordValue: mortgageData.recordDetails.primaryMortgage.PrimaryMortgageStartDate.publicRecordValue,
          oldDiscrepancy: mortgageData.recordDetails.primaryMortgage.PrimaryMortgageStartDate.discrepancy,
          recordFieldRoot: 'primaryMortgage',
          dateFormat: 'MMM Do, yyyy',
          discardLead: false,
          teamId: teamId,
          selection: null,
          financialsUpdated: true,
          origin: 'provideFinancials',
          leadStatus: leadStatus,
        })
        if (resp.error) {
          recordUpdateError = true
        }
      }
      if (mortgageData.mortgageTerm > 0) {
        newMortgageTerm = mortgageData.mortgageTerm 
      } else {
        newMortgageTerm = mortgageTerm
        let resp = await editOneMortgageDetail({
          userId: userId,
          userFullName: userFullName,
          mortgageId: mortgageData._id,
          leadId: leadId,
          recordField: 'PrimaryMortgageTerm',
          customValue: mortgageTerm,
          activeDiscrepancies: mortgageData.activeDiscrepancies,
          resolvedDiscrepancies: mortgageData.resolvedDiscrepancies,
          rejectedDiscrepancies: mortgageData.rejectedDiscrepancies,
          publicRecordValue: mortgageData.recordDetails.primaryMortgage.PrimaryMortgageTerm.publicRecordValue,
          oldDiscrepancy: mortgageData.recordDetails.primaryMortgage.PrimaryMortgageTerm.discrepancy,
          recordFieldRoot: 'primaryMortgage',
          dateFormat: null,
          discardLead: false,
          teamId: teamId,
          selection: null,
          financialsUpdated: true,
          origin: 'provideFinancials',
          leadStatus: leadStatus,
        })
        if (resp.error) {
          recordUpdateError = true
        }
      }
      if (mortgageData.originalLoanAmount > 0) {
        newOriginalLoanAmount = mortgageData.originalLoanAmount 
      } else {
        newOriginalLoanAmount = parseFloat(originalLoanAmount)
        let resp = await editOneMortgageDetail({
          userId: userId,
          userFullName: userFullName,
          mortgageId: mortgageData._id,
          leadId: leadId,
          recordField: 'PrimaryMortgageAmount',
          customValue: originalLoanAmount,
          activeDiscrepancies: mortgageData.activeDiscrepancies,
          resolvedDiscrepancies: mortgageData.resolvedDiscrepancies,
          rejectedDiscrepancies: mortgageData.rejectedDiscrepancies,
          publicRecordValue: mortgageData.recordDetails.primaryMortgage.PrimaryMortgageAmount.publicRecordValue,
          oldDiscrepancy: mortgageData.recordDetails.primaryMortgage.PrimaryMortgageAmount.discrepancy,
          recordFieldRoot: 'primaryMortgage',
          dateFormat: null,
          discardLead: false,
          teamId: teamId,
          selection: null,
          financialsUpdated: true,
          origin: 'provideFinancials',
          leadStatus: leadStatus,
        })
        if (resp.error) {
          recordUpdateError = true
        }
      }
      if (mortgageData.originalInterestRate > 0) {
        newOriginalInterestRate = mortgageData.originalInterestRate 
      } else {
        newOriginalInterestRate = parseFloat(originalInterestRate)
        let resp = await editOneMortgageDetail({
          userId: userId,
          userFullName: userFullName,
          mortgageId: mortgageData._id,
          leadId: leadId,
          recordField: 'PrimaryMortgageInterestRate',
          customValue: originalInterestRate,
          activeDiscrepancies: mortgageData.activeDiscrepancies,
          resolvedDiscrepancies: mortgageData.resolvedDiscrepancies,
          rejectedDiscrepancies: mortgageData.rejectedDiscrepancies,
          publicRecordValue: mortgageData.recordDetails.primaryMortgage.PrimaryMortgageInterestRate.publicRecordValue,
          oldDiscrepancy: mortgageData.recordDetails.primaryMortgage.PrimaryMortgageInterestRate.discrepancy,
          recordFieldRoot: 'primaryMortgage',
          dateFormat: null,
          discardLead: false,
          teamId: teamId,
          selection: null,
          financialsUpdated: true,
          origin: 'provideFinancials',
          leadStatus: leadStatus,
        })
        if (resp.error) {
          recordUpdateError = true
        }
      }
      if (!recordUpdateError) {
        let assessedValue = mortgageData.recordDetails.assessment.AssessedValue.currentValue
        if (assessedValue.length > 0) {
          assessedValue = parseFloat(assessedValue)
        } else {
          assessedValue = 0
        }
        let reqObj = {
          mortgageId: mortgageData._id,
          activeLeadId: mortgageData.activeLead,
          userFullName: userFullName,
          teamId: teamId,
          newOriginationDate: newOriginationDate,
          newMortgageTerm: parseInt(newMortgageTerm),
          newOriginalLoanAmount: newOriginalLoanAmount,
          newOriginalInterestRate: newOriginalInterestRate,
          targetInterestRate: parseFloat(teamDefaultInterestRate),
          userId: userId,
          assessedValue: assessedValue,
        }
        let resp = await provideFinancialInformation(reqObj)
        if (resp.error) {
          setSaveIsError(true)
        } else {
          let reload = await reloadTeamPortfolioMonthlyStats({
            userFullName: userFullName,
            teamId: teamId,
          })
          if (reload.error) {
            setSaveIsError(true)
          } else {
            setSaveIsSuccess(true)
          }
        }
      } else {
        setSaveIsError(true)
      }
    } else {
      setInvalidInputs(true)
      dispatch( setSaveFinancialInformationEnabled(false) )
    }
    setSaveIsFetching(false)
  }

  useEffect(() => {
    if (!mortgageData.originationDate > 0) {
      setMortgageDateRequired(true)
    }
    if (!mortgageData.mortgageTerm > 0) {
      setMortgageTermRequired(true)
    }
    if (!mortgageData.originalLoanAmount > 0) {
      setLoanAmountRequired(true)
    }
    if (!mortgageData.originalInterestRate > 0) {
      setInterestRateRequired(true)
    }
    if (mortgageData.amortizationSchedule) {
      setNewPaymentSchedule(mortgageData.amortizationSchedule.apiMapping)
      setNewPaymentScheduleLabel(mortgageData.amortizationSchedule.label)
    } else if (teamPaymentSchedules !== null) {
      setNewPaymentSchedule(teamPaymentSchedules[0].apiMapping)
      setNewPaymentScheduleLabel(teamPaymentSchedules[0].label)
    }
  }, [mortgageData, teamPaymentSchedules])

  return (
    <FinancialPanel>
      {saveIsSuccess ?
        <PanelHeader $tone="success">
          <HeaderIcon>
            <CheckIcon />
          </HeaderIcon>
          <HeaderText>Success</HeaderText>
        </PanelHeader>
      : saveIsError ?
        <PanelHeader $tone="error">
          <HeaderIcon>
            <ErrorIcon />
          </HeaderIcon>
          <HeaderText>
            Failed... please try again. Reach out to support@lancastersweep.com if the problem persists.
          </HeaderText>
        </PanelHeader>
      :
        <PanelHeader>
          <HeaderText>Loan Details</HeaderText>
          <HeaderMeta>Confirm the financial terms required for this investigation path.</HeaderMeta>
        </PanelHeader>
      }
      <PanelBody>
        <PanelScroll>
        {saveIsSuccess || (!mortgageTermRequired && !loanAmountRequired && !interestRateRequired && !amortizationScheduleRequired &&  !mortgageDateRequired) ?
          <StatusCallout>
            <CalloutTitle>{saveIsSuccess ? 'Financial details saved' : 'Financial details complete'}</CalloutTitle>
            <CalloutCopy>
              {saveIsSuccess ? 'The loan details are now available for the next lead action.' : 'No additional financial inputs are required for this lead.'}
            </CalloutCopy>
          </StatusCallout>
        : invalidInputs ?
          <StatusCallout $tone="error">
            <CalloutTitle>Please provide the following financial information</CalloutTitle>
            <CalloutCopy>
              <ErrorIcon />
              Invalid inputs. Please try again.
            </CalloutCopy>
          </StatusCallout>
        :
          <StatusCallout>
            <CalloutTitle>Please provide the following financial information</CalloutTitle>
            <CalloutCopy>Required values are marked with an asterisk.</CalloutCopy>
          </StatusCallout>
        }
        <FinancialSurface>
          <FinancialWorkspace>
            <ContextColumn>
              <SectionHeader>
                <SectionTitle>Current Loan Record</SectionTitle>
                <SectionMeta>Existing financial terms stay visible while missing details are completed.</SectionMeta>
              </SectionHeader>
              <SummaryGrid>
                {mortgageData.originationDateLabel.length > 0 &&
                  <SummaryItem>
                    <SummaryLabel>
                        origination date:
                    </SummaryLabel>
                    <SummaryValue>
                        {mortgageData.originationDateLabel}
                    </SummaryValue>
                  </SummaryItem>
                }
                {mortgageData.mortgageTerm > 0 &&
                  <SummaryItem>
                    <SummaryLabel>
                        term:
                    </SummaryLabel>
                    <SummaryValue>
                        {mortgageData.mortgageTerm} years
                    </SummaryValue>
                  </SummaryItem>
                }
                {mortgageData.originalLoanAmount > 0 &&
                  <SummaryItem>
                    <SummaryLabel>
                        original loan amount:
                    </SummaryLabel>
                    <SummaryValue>
                        ${mortgageData.originalLoanAmount.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}
                    </SummaryValue>
                  </SummaryItem>
                }
                {mortgageData.originalInterestRate > 0 &&
                  <SummaryItem>
                    <SummaryLabel>
                        original interest rate:
                    </SummaryLabel>
                    <SummaryValue>
                        {mortgageData.originalInterestRate}%
                    </SummaryValue>
                  </SummaryItem>
                }
                {mortgageData.amortizationSchedule &&
                  <ScheduleSummary style={{margin: saveIsSuccess ? '0 auto' : '1rem auto 0 auto'}}>
                    <FlexWrapper className="fitContentHeight">
                      <FlexWrapper className="justifyEnd">
                        <Typography className="mediumHeight" style={{alignItems: 'center'}}>
                          mortgage schedule:
                        </Typography>
                      </FlexWrapper>
                      <FlexWrapper style={{paddingLeft: '0.5rem'}}>
                        {saveIsSuccess ?
                          <Typography className="medium bold">
                            {newPaymentScheduleLabel}
                          </Typography>
                        :
                          <PaymentScheduleDropdown
                            style={{width: '100%'}}
                            value={newPaymentSchedule}
                            handleChange={handleSetNewPaymentSchedule}
                            items={teamPaymentSchedules}
                            amortizationScheduleRequired={amortizationScheduleRequired}
                          />
                        }
                      </FlexWrapper>
                    </FlexWrapper>
                  </ScheduleSummary>
                }
              </SummaryGrid>
            </ContextColumn>
            <TermsColumn>
              <SectionHeader>
                <SectionTitle>Required Financial Inputs</SectionTitle>
                <SectionMeta>Missing source-record terms are collected before financial calculations continue.</SectionMeta>
              </SectionHeader>
              <FieldGrid>
              {!mortgageData.originationDateLabel.length > 0 &&
                <InputWrapper className="alignStart" style={{width: '15rem', margin: '0 auto 1rem auto'}}>
                  <StatusAndLabelWrapper className='column'>
                    <FlexWrapper>
                      <Typography htmlFor="root-portal">Mortgage Start Date</Typography>
                      <Typography className="required">*</Typography>
                    </FlexWrapper>
                  </StatusAndLabelWrapper>
                  <FlexWrapper className="alignCenter fitContentHeight">
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      maxDate={addDays(new Date(), 0)}
                      minDate={subMonths(new Date(), 360)}
                      showMonthDropdown
                      showYearDropdown
                      scrollableYearDropdown
                      yearDropdownItemNumber={10}
                      withPortal
                      portalId="root-portal"
                      customInput={<ExampleCustomInput />}
                      dayClassName={() => "example-datepicker-day-class"}
                      calendarClassName="example-datepicker-class"
                      todayButton="CLICK FOR TODAY'S DATE"
                    />
                  </FlexWrapper>
                </InputWrapper>
              }
              {!mortgageData.mortgageTerm > 0 &&
                <InputWrapper className="alignStart" style={{width: '15rem', margin: '0 auto 1rem auto'}}>
                  <StatusAndLabelWrapper style={{height: '2.4rem'}}>
                    <FlexWrapper className="fitContentWidth">
                      <Typography htmlFor="mortgageTerm">Mortgage Term (years)</Typography>
                      <Typography className="required">*</Typography>
                    </FlexWrapper>
                  </StatusAndLabelWrapper>
                  <FlexWrapper className="alignCenter fitContentHeight">
                    <StyledInputElement
                      style={{width: '10rem', marginRight: '1rem'}}
                      value={mortgageTerm}
                      type="text"
                      name="mortgageTerm"
                      id="mortgageTerm"
                      ref={mortgageTermRef}
                      className={(statusMortgageTerm) ? 'error' : (mortgageTermRef.current && parseInt(mortgageTermRef.current.value) > 0) ? 'populated' : mortgageTermRequired ? 'required' :  ''}
                      onChange={() => validateMortgageTerm()}
                    />
                    {statusMortgageTerm === "nonNumber" && (
                      <ErrorWrapper>
                        <ErrorIcon />
                        Must be a number
                      </ErrorWrapper>
                    )}
                    {statusMortgageTerm === "decimal" && (
                      <ErrorWrapper>
                        <ErrorIcon />
                        Must be a whole number
                      </ErrorWrapper>
                    )}
                    {statusMortgageTerm === "negative" && (
                      <ErrorWrapper>
                        <ErrorIcon />
                        Can't be negative
                      </ErrorWrapper>
                    )}
                    {statusMortgageTerm === "zero" && (
                      <ErrorWrapper>
                        <ErrorIcon />
                        Can't be zero
                      </ErrorWrapper>
                    )}
                    {statusMortgageTerm === "large" && (
                      <ErrorWrapper>
                        <ErrorIcon />
                        {`Must be < 99`}
                      </ErrorWrapper>
                    )}
                  </FlexWrapper>
                </InputWrapper>
              }
              {!mortgageData.originalLoanAmount > 0 &&
                <InputWrapper className="alignStart" style={{width: '15rem', margin: '0 auto 1rem auto'}}>
                  <StatusAndLabelWrapper style={{height: '2.4rem'}}>
                    <FlexWrapper>
                      <Typography htmlFor="originalLoanAmount">Original Loan Amount ($)</Typography>
                      <Typography className="required">*</Typography>
                    </FlexWrapper>
                  </StatusAndLabelWrapper>
                  <FlexWrapper className="alignCenter fitContentHeight">
                    <StyledInputElement
                      style={{width: '10rem', marginRight: '1rem'}}
                      value={originalLoanAmountStr}
                      type="text"
                      name="originalLoanAmount"
                      id="originalLoanAmount"
                      ref={originalLoanAmountRef}
                      className={(statusOriginalLoanAmount && statusOriginalLoanAmount !== 'required') ? 'error' : (originalLoanAmountRef.current && parseFloat(originalLoanAmountRef.current.value) > 0) ? 'populated' : loanAmountRequired ? 'required' : ''}
                      onChange={() => validateLoanAmount()}
                    />
                    {statusOriginalLoanAmount === "nonNumber" && (
                      <ErrorWrapper>
                        <ErrorIcon />
                        Must be a number
                      </ErrorWrapper>
                    )}
                    {statusOriginalLoanAmount === "negative" && (
                      <ErrorWrapper>
                        <ErrorIcon />
                        Can't be negative
                      </ErrorWrapper>
                    )}
                    {statusOriginalLoanAmount === "zero" && (
                      <ErrorWrapper>
                        <ErrorIcon />
                        Can't be zero
                      </ErrorWrapper>
                    )}
                    {statusOriginalLoanAmount === "large" && (
                      <ErrorWrapper>
                        <ErrorIcon />
                        {`Must be < 100m`}
                      </ErrorWrapper>
                    )}
                  </FlexWrapper>
                </InputWrapper>
              }
              {!mortgageData.originalInterestRate > 0 &&
                <InputWrapper className="alignStart" style={{width: '15rem', margin: '0 auto 1rem auto'}}>
                  <StatusAndLabelWrapper style={{height: '2.4rem'}}>
                    <FlexWrapper>
                      <Typography htmlFor="originalInterestRate">Original Interest Rate (%)</Typography>
                      <Typography className="required">*</Typography>
                    </FlexWrapper>
                  </StatusAndLabelWrapper>
                  <FlexWrapper className="alignCenter fitContentHeight">
                    <StyledInputElement
                      style={{width: '10rem', marginRight: '1rem'}}
                      value={originalInterestRate}
                      type="text"
                      name="originalInterestRate"
                      id="originalInterestRate"
                      ref={originalInterestRateRef}
                      className={(statusOriginalInterestRate && statusOriginalInterestRate !== 'required') ? 'error' : (originalInterestRateRef.current && parseFloat(originalInterestRateRef.current.value) > 0) ? 'populated' : interestRateRequired ? 'required' : ''}
                      onChange={() => validateInterestRate()}
                    />
                    {statusOriginalInterestRate === "nonNumber" && (
                      <ErrorWrapper>
                        <ErrorIcon />
                        Must be a number
                      </ErrorWrapper>
                    )}
                    {statusOriginalInterestRate === "negative" && (
                      <ErrorWrapper>
                        <ErrorIcon />
                        Can't be negative
                      </ErrorWrapper>
                    )}
                    {statusOriginalInterestRate === "zero" && (
                      <ErrorWrapper>
                        <ErrorIcon />
                        Can't be zero
                      </ErrorWrapper>
                    )}
                    {statusOriginalInterestRate === "large" && (
                      <ErrorWrapper>
                        <ErrorIcon />
                        {`Must be < 99`}
                      </ErrorWrapper>
                    )}
                  </FlexWrapper>
                </InputWrapper>
              }
              {!mortgageData.amortizationSchedule &&
                <InputWrapper style={{margin: saveIsSuccess ? '0 auto' : '1rem auto 0 auto'}}>
                  <FlexWrapper className="fitContentHeight">
                    <FlexWrapper className="justifyEnd">
                      <Typography className="mediumHeight" style={{alignItems: 'center'}}>
                        amortization schedule:
                      </Typography>
                    </FlexWrapper>
                    <FlexWrapper style={{paddingLeft: '0.5rem'}}>
                      {saveIsSuccess ?
                        <Typography className="medium bold">
                          {newPaymentScheduleLabel}
                        </Typography>
                      :
                        <PaymentScheduleDropdown
                          style={{width: '100%'}}
                          value={newPaymentSchedule}
                          handleChange={handleSetNewPaymentSchedule}
                          items={teamPaymentSchedules}
                        />
                      }
                    </FlexWrapper>
                    <Typography className="required" style={{margin: '0 0 auto 0'}}>*</Typography>
                  </FlexWrapper>
                </InputWrapper>
              }
              </FieldGrid>
            </TermsColumn>
          </FinancialWorkspace>
          {/* {((mortgageData.originationDateLabel.length > 0 || mortgageData.mortgageTerm > 0 || mortgageData.originalLoanAmount > 0 || mortgageData.originalInterestRate > 0) && !saveIsSuccess && !saveIsError) &&
            <Typography className="info alignStart justifyCenter" style={{margin: '1rem 1.5rem 0 0'}}>
              <InfoIcon style={{margin: '0 0.2rem 0 0'}} />
              These values are pulled from internal records.<br/>
              If you'd like to provide different loan details,<br/>
              do so in the "Compare and Update Records" tab
            </Typography>
          } */}
        </FinancialSurface>
        </PanelScroll>
        <PanelFooter>
        <FooterActions className="marginAuto">
          {(saveIsSuccess && navSelection === 'provideFinancialsModal') ?
            <Button style={{width: '23rem'}} className="primary" onClick={() => dispatch( setLeadActionNavMenuSelection('editTargets') )}>
              Back to Refinance Targets
            </Button>
          : (saveIsSuccess && navSelection === 'provideFinancialsCard') ?
            <Button style={{width: '21rem'}} className="primary" onClick={() => handleCloseModal()}>
              Back to Active Leads
            </Button>
          : (saveIsSuccess && navSelection === 'provideTerms') ?
            <Button style={{width: '11rem'}} className="neutral" onClick={() => handleCloseModal()}>
              Close
            </Button>
          : (!mortgageTermRequired && !loanAmountRequired && !interestRateRequired && !amortizationScheduleRequired && !mortgageDateRequired) ?
            <Button 
              className="neutral"
              onClick={navSelection === 'provideFinancialsModal' ? () => dispatch( setLeadActionNavMenuSelection('editTargets') ) : () => handleCloseModal()}>
              Go Back
            </Button>
          :
            <>
              <Button 
                className={saveIsFetching ? 'neutralLoading' : 'neutral'}
                disabled={saveIsFetching}
                onClick={saveIsFetching ? null 
                  : navSelection === 'provideFinancialsModal' ? () => dispatch( setLeadActionNavMenuSelection('editTargets') ) 
                  : () => handleCloseModal()
                }
              >
                {navSelection === 'provideFinancialsModal' ?
                  `Go Back`
                :
                  `Close`
                }
              </Button>
              <Button 
                className={saveIsFetching ? 'primaryLoading' : (!saveIsError && saveFinancialInformationEnabled) ? 'primary' : 'primaryDisabled'}
                disabled={saveIsError || saveIsFetching || !saveFinancialInformationEnabled}
                onClick={(!saveIsError && !saveIsFetching && saveFinancialInformationEnabled) ? () => handleSave() : null}
              >
                {saveIsFetching ?
                  <CircularProgress
                    sx={{ color: `${theme.palette.common.white}` }}
                    size={18}
                  />
                :
                  `Save`
                }
              </Button>
            </>
          }
        </FooterActions>
        </PanelFooter>
      </PanelBody>
    </FinancialPanel>
  )
}

const FinancialPanel = styled.section(({ theme }) => `
  width: 100%;
  height: 100%;
  max-height: 100%;
  min-width: 0;
  min-height: 0;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  background: ${theme.palette.common.cardBackground};
  overflow: hidden;
`)

const PanelHeader = styled.header(({ theme, $tone }) => {
  const isSuccess = $tone === "success";
  const isError = $tone === "error";
  const toneColor = isSuccess
    ? theme.palette.primary.dark
    : isError
      ? theme.palette.common.redDark
      : theme.palette.common.grayText;
  const toneBackground = isSuccess
    ? theme.palette.primary.labelTransparent
    : isError
      ? theme.palette.common.redTransparent
      : theme.palette.common.white;

  return `
    min-height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.7rem;
    padding: 0.8rem 1rem;
    border-bottom: 0.1rem solid ${theme.palette.common.grayBorder};
    background: ${toneBackground};
    color: ${toneColor};
  `;
})

const HeaderIcon = styled.div(({ theme }) => `
  width: 2.4rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border-radius: 0.6rem;
  background: ${theme.palette.common.white};
  border: 0.1rem solid currentColor;

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`)

const HeaderText = styled.span`
  color: inherit;
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
  font-family: -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", 'Inter', "Helvetica Neue", sans-serif;
`

const HeaderMeta = styled.span(({ theme }) => `
  color: ${theme.palette.common.grayText};
  font-size: 0.9rem;
  font-weight: 600;
`)

const PanelBody = styled.div(({ theme }) => `
  min-height: 0;
  display: grid;
  grid-template-rows: minmax(0, 1fr) auto;
  overflow: hidden;
  background: ${theme.palette.common.grayBorderLight};
`)

const PanelScroll = styled.div(({ theme }) => `
  min-height: 0;
  height: 100%;
  max-height: 100%;
  display: grid;
  align-content: start;
  gap: 1rem;
  padding: 1rem;
  overflow-x: auto;
  overflow-y: auto;

  ::-webkit-scrollbar-thumb {
    border: 0.1rem solid ${theme.palette.common.grayText};
    background-color: ${theme.palette.common.grayText};
  }

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    border: 0.05rem solid ${theme.palette.common.grayBorderDark};
    background-color: ${theme.palette.common.pageBackground};
  }

  ::-webkit-scrollbar:vertical {
    width: 0.4rem;
  }
`)

const StatusCallout = styled.div(({ theme, $tone }) => `
  display: grid;
  gap: 0.45rem;
  padding: 1rem 1.2rem;
  border: 0.1rem solid ${$tone === "error" ? theme.palette.common.errorRowDark : theme.palette.common.grayBorder};
  border-left: 0.35rem solid ${$tone === "error" ? theme.palette.common.redDark : theme.palette.primary.dark};
  border-radius: 0.8rem;
  background: ${$tone === "error" ? theme.palette.common.redTransparent : theme.palette.common.white};
`)

const CalloutTitle = styled.div(({ theme }) => `
  color: ${theme.palette.common.black};
  font-size: 1rem;
  font-weight: 800;
`)

const CalloutCopy = styled.div(({ theme }) => `
  display: flex;
  align-items: center;
  gap: 0.45rem;
  color: ${theme.palette.common.grayText};
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.4;

  svg {
    width: 1.1rem;
    height: 1.1rem;
    color: ${theme.palette.common.redDark};
  }
`)

const FinancialSurface = styled.div(({ theme }) => `
  min-height: 0;
  min-width: 76rem;
  width: fit-content;
  display: grid;
  justify-self: center;
  gap: 1rem;
  padding: 1rem;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.8rem;
  background: ${theme.palette.common.white};
`)

const FinancialWorkspace = styled.div`
  display: grid;
  grid-template-columns: minmax(24rem, 0.9fr) minmax(34rem, 1.1fr);
  align-items: start;
  gap: 1rem;
`

const ContextColumn = styled.section(({ theme }) => `
  display: grid;
  align-content: start;
  gap: 1rem;
  min-height: 100%;
  padding: 1rem;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.75rem;
  background: ${theme.palette.common.cardBackground};
`)

const TermsColumn = styled.section(({ theme }) => `
  display: grid;
  align-content: start;
  gap: 1rem;
  min-height: 100%;
  padding: 1rem;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.75rem;
  background: ${theme.palette.common.white};
`)

const SectionHeader = styled.div`
  display: grid;
  gap: 0.25rem;
`

const SectionTitle = styled.div(({ theme }) => `
  color: ${theme.palette.common.black};
  font-size: 0.95rem;
  font-weight: 800;
  text-transform: uppercase;
`)

const SectionMeta = styled.div(({ theme }) => `
  color: ${theme.palette.common.grayText};
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.35;
`)

const FieldGrid = styled.div(({ theme }) => `
  display: grid;
  grid-template-columns: repeat(2, minmax(15rem, 1fr));
  gap: 0.9rem;

  > div {
    width: auto !important;
    min-width: 0;
    min-height: 8rem;
    align-items: flex-start;
    margin: 0 !important;
    padding: 1rem;
    border: 0.1rem solid ${theme.palette.common.grayBorder};
    border-radius: 0.7rem;
    background: ${theme.palette.common.cardBackground};
  }

  input {
    max-width: 100%;
  }
`)

const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(10rem, 1fr));
  gap: 0.75rem;
`

const SummaryItem = styled.div(({ theme }) => `
  min-height: 5rem;
  display: grid;
  align-content: center;
  gap: 0.35rem;
  padding: 0.9rem 1rem;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.7rem;
  background: ${theme.palette.common.cardBackground};
`)

const SummaryLabel = styled.div(({ theme }) => `
  color: ${theme.palette.common.grayText};
  font-size: 0.75rem;
  font-weight: 800;
  text-transform: uppercase;
`)

const SummaryValue = styled.div(({ theme }) => `
  color: ${theme.palette.common.black};
  font-size: 1rem;
  font-weight: 800;
`)

const ScheduleSummary = styled(InputWrapper)(({ theme }) => `
  grid-column: 1 / -1;
  width: auto !important;
  padding: 0.9rem 1rem;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.7rem;
  background: ${theme.palette.common.cardBackground};
`)

const PanelFooter = styled.footer(({ theme }) => `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  border-top: 0.1rem solid ${theme.palette.common.grayBorder};
  background: ${theme.palette.common.white};
`)

const FooterActions = styled(ButtonWrapper)`
  width: 100%;
  max-width: 34rem;
  justify-content: center;
  gap: 0.75rem;
  margin: 0 auto;
`

export default ProvideFinancials;
